// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const excluirEmpreendimentosService = async (empreendId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/empreendimento/${empreendId}`;
    try {
      const response = await axios.delete(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        // repassa o objeto do backend (code + message)
        throw error.response.data;
      }
      throw new Error("Erro ao excluir empreendimento");
    }
  }
};
